(function () {
  try {
    var root = document.querySelector('[data-section-type="product"]') || document.getElementById('mp-main');
    if (!root) return;

    var wrapEl = root.querySelector('.mp__gallery-slider-wrap');
    var slider = root.querySelector('[data-mp-slider]');
    var slides = root.querySelectorAll('.mp__gallery-slide');
    var prevBtn = root.querySelector('[data-mp-prev]');
    var nextBtn = root.querySelector('[data-mp-next]');
    var dots = root.querySelectorAll('.mp__dot');
    var currentIndex = 0;
    var totalSlides = slides.length;

    /* PRE-CACHE ALL GALLERY IMAGES */
    slides.forEach(function(slide) {
      var img = slide.querySelector('img');
      if (img && img.src) {
        var preloader = new Image();
        preloader.src = img.src;
      }
    });

    /* WATCHDOG: if any other script moves/re-parents the arrow buttons
       (e.g. a theme "sticky header" script that grabs generic arrow/nav
       selectors), snap them back into the image container immediately. */
    var arrowsRafPending = false;
    function ensureArrowsInPlace() {
      arrowsRafPending = false;
      if (!wrapEl) return;
      if (prevBtn && prevBtn.parentElement !== wrapEl) {
        wrapEl.insertBefore(prevBtn, wrapEl.firstChild);
      }
      if (nextBtn && nextBtn.parentElement !== wrapEl) {
        wrapEl.insertBefore(nextBtn, wrapEl.firstChild);
      }
    }
    function scheduleEnsureArrows() {
      if (arrowsRafPending) return;
      arrowsRafPending = true;
      window.requestAnimationFrame(ensureArrowsInPlace);
    }
    window.addEventListener('scroll', scheduleEnsureArrows, { passive: true });
    window.addEventListener('resize', scheduleEnsureArrows, { passive: true });
    ensureArrowsInPlace();

    function updateArrowVisibility() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.style.display = (currentIndex === 0) ? 'none' : 'flex';
      nextBtn.style.display = (currentIndex === totalSlides - 1) ? 'none' : 'flex';
    }

    function goToSlide(index) {
      if (index < 0 || index >= totalSlides) return;
      currentIndex = index;

      if (slider) {
        var slideWidth = slider.clientWidth;
        slider.scrollTo({
          left: slideWidth * currentIndex,
          behavior: 'smooth'
        });
      }

      dots.forEach(function (d, i) {
        if (i === currentIndex) d.classList.add('is-active');
        else d.classList.remove('is-active');
      });

      updateArrowVisibility();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToSlide(currentIndex + 1);
      });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(d.dataset.index, 10);
        goToSlide(idx);
      });
    });

    /* NATIVE TOUCH & SWIPE SCROLL SYNC */
    if (slider) {
      var scrollTimer = null;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var slideWidth = slider.clientWidth;
          if (slideWidth > 0) {
            var newIdx = Math.round(slider.scrollLeft / slideWidth);
            if (newIdx !== currentIndex && newIdx >= 0 && newIdx < totalSlides) {
              currentIndex = newIdx;
              dots.forEach(function (d, i) {
                if (i === currentIndex) d.classList.add('is-active');
                else d.classList.remove('is-active');
              });
              updateArrowVisibility();
            }
          }
        }, 50);
      }, { passive: true });
    }

    /* LISTEN FOR VARIANT CHANGED EVENT */
    document.addEventListener('mp:variant-changed', function (e) {
      var card = e.detail ? e.detail.card : null;
      if (!card) return;

      var vId = card.dataset.variantId;
      var matchingSlide = Array.from(slides).findIndex(function (s) {
        return s.dataset.variantId === vId;
      });

      if (matchingSlide !== -1) {
        goToSlide(matchingSlide);
      }
    });

    updateArrowVisibility();
  } catch (err) {
    console.error('mp-gallery script error:', err);
  }
})();